export const THEME_KEY = 'ParaScopeTheme';

export type Theme = 'light' | 'dark'
